import {DefaultAdminProps} from '../types/user-detail-tab-props';

/** Maximum row level used to hide deeper breeder actions. */
export const thirdLevel = 3;

/** Sentinel value used to represent a selected "all" option in multi-selects. */
export const allOptionValue = Number.MAX_SAFE_INTEGER;

/** Default admin props used when the tab is rendered outside the admin module. */
export const defaultProps: DefaultAdminProps = {
    canUpdate: false,
    userProfileId: NaN,
    createEntry: undefined,
    updateEntry: undefined,
    deleteEntry: undefined,
};
